import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '../views/layout/MainLayout'
import NoticeLayout from '../views/layout/NoticeLayout'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: MainLayout,
    children:[
      {
        path: '/',
        name: 'dashboard',
        component: () => import('../views/DashboardView.vue'),
        meta: { title: '欢迎' }
      }
    ]
  },
  {
    path: '/',
    component: MainLayout,
    children:[
      {
        path: '/article',
        name: 'Article',
        component: () => import('../views/Article/IndexView.vue'),
        redirect: 'noRedirect',
        alwaysShow: true,
        meta: { title: '资讯管理', access: 'article' },
        children:[
          {
            path: '/article/list',
            name: 'ArticleList',
            component: () => import('../views/Article/ListView.vue'),
            meta: { title: '资讯列表', access: 'article_list' }
          },
          {
            path: '/article/add',
            name: 'ArticleAdd',
            hidden: true,
            component: () => import('../views/Article/FormView.vue'),
            meta: { title: '添加资讯', access: 'article_add' }
          },
          {
            path: '/article/edit',
            name: 'ArticleEdit',
            hidden: true,
            component: () => import('../views/Article/FormView.vue'),
            meta: { title: '编辑资讯', access: 'article_edit' }
          },
          {
            path: '/article/delete',
            name: 'ArticleDelete',
            hidden: true,
            component: () => import('../views/Article/IndexView.vue'),
            meta: { title: '删除资讯', access: 'article_delete' }
          }
        ]
      },
      {
        path: '/admin',
        name: 'Admin',
        component: () => import('../views/Admin/IndexView.vue'),
        redirect: 'noRedirect',
        alwaysShow: true,
        meta: { title: '管理员', access: 'admin' },
        children:[
          {
            path: '/admin/list',
            name: 'AdminList',
            component: () => import('../views/Admin/ListView.vue'),
            meta: { title: '管理员列表', access: 'admin_list' }
          },
          {
            path: '/admin/add',
            name: 'AdminAdd',
            hidden: true,
            component: () => import('../views/Admin/FormView.vue'),
            meta: { title: '添加管理员', access: 'admin_add' }
          },
          {
            path: '/admin/edit',
            name: 'AdminEdit',
            hidden: true,
            component: () => import('../views/Admin/FormView.vue'),
            meta: { title: '编辑管理员', access: 'admin_edit' }
          },
          {
            path: '/admin/delete',
            name: 'AdminDelete',
            hidden: true,
            component: () => import('../views/Admin/IndexView.vue'),
            meta: { title: '删除管理员', access: 'admin_delete' }
          },
          {
            path: '/admin/role/list',
            name: 'AdminRoleList',
            component: () => import('../views/AdminRole/ListView.vue'),
            meta: { title: '角色列表', access: 'admin_role' }
          },
          {
            path: '/admin/role/add',
            name: 'AdminRoleAdd',
            hidden: true,
            component: () => import('../views/AdminRole/IndexView.vue'),
            meta: { title: '添加角色', access: 'admin_role_add' }
          },
          {
            path: '/admin/role/edit',
            name: 'AdminRoleEdit',
            hidden: true,
            component: () => import('../views/AdminRole/IndexView.vue'),
            meta: { title: '编辑角色', access: 'admin_role_edit' }
          },
          {
            path: '/admin/role/delete',
            name: 'AdminRoleDelete',
            hidden: true,
            component: () => import('../views/AdminRole/IndexView.vue'),
            meta: { title: '删除角色', access: 'admin_role_delete' }
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: NoticeLayout,
    children:[
      {
        path: '/access_deny',
        name:'AccessDeny',
        component: () => import('@/views/AccessDeny'),
        hidden: true,
        meta: { title: '权限不足' }
      },
      {
        path: '/404',
        name:'404',
        component: () => import('@/views/404'),
        hidden: true,
        meta: { title: '404' }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
